import { memo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { EmptyStateCell } from './EmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
const DomainCell = ({
  value
}) => {
  const defaultProtocol = 'http';
  const validUrl = value && value.startsWith(defaultProtocol) ? value : `${defaultProtocol}://${value}`;
  if (!value) {
    return /*#__PURE__*/_jsx(EmptyStateCell, {});
  }
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: validUrl,
    truncate: false,
    children: value
  });
};
export default /*#__PURE__*/memo(DomainCell);